import { useState } from "react";
import { 
  INoCessionSIPSErrors,
  INoCessionSIPSErrorsResponse,
  NoSIPSCessionSelection, 
  NoSIPSCessionStates
} from "../types/noSIPSCession";
import { 
  default as noSIPSCessionService
} from "../services/noSIPSCession";
import axios from "axios";
import { 
  setNoSIPSCessionState,
  setNoSIPSCessionIsWaitingForSignature
} from "@/actions/contracts";
import { useDispatch } from "react-redux";

interface IUseNoSIPSCessionProps {
  contractName: string;
  handleClose: () => void;
}

const useNoSIPSCession = ({
  contractName,
  handleClose
}: IUseNoSIPSCessionProps) => {
  const dispatch = useDispatch();

  const [errors, setErrors] = useState<INoCessionSIPSErrors | undefined>();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmitNoSIPSCession = async (
    newNoSIPSCessionSelection: NoSIPSCessionSelection
  ) => {
    dispatch(setNoSIPSCessionState("requested"));
    setIsSubmitting(true);

    noSIPSCessionService.sendSIPSCessionChange({
      contractName,
      newNoSIPSCessionSelection
    })
    .then(res => {
      dispatch(setNoSIPSCessionIsWaitingForSignature(res.promise.data.waiting_for_signature));
      if(!res.promise.data.waiting_for_signature) {
        handleClose();
      }
    })
    .catch(err => {
      dispatch(setNoSIPSCessionState('unactive'));
      if (axios.isAxiosError<INoCessionSIPSErrorsResponse>(err))  {
        if (err.response?.status === 400) {
          setErrors(err.response?.data.errors);
        }
      }
    })
    .finally(() => {
      setIsSubmitting(false);
    })
  };

  return {
    errors,
    isSubmitting,
    handleSubmitNoSIPSCession
  }

}

export default useNoSIPSCession;